export default __webpack_public_path__ + "static/media/assessment-icon.2308c2a9.svg";